<template>
  <v-card
    class="template-gallery__item user"
    @click="onTemplateGalleryItemClick"
    :loading="loading"
    :disabled="loading"
  >
    <!--
    <div
      v-if="templateType === 'userPublished'"
      style="display: flex; flex-direction: column; text-align: center; align-items: center; padding: 20px 15px;"
    >
      <v-chip
          v-if="template && isMine"
          color="green"
          text-color="white"
          small
          style="position: absolute; right: 8px; top: -6px; font-size: 12px;"
      >
        {{ translate('ui_my_template') }}
      </v-chip>

      <v-avatar size="65" tile>
        <i v-if="template && template.faIcon" :class=template.faIcon style="font-size: 26px; color: #1876d2;"></i>
      </v-avatar>
      <v-card-title
          style="justify-content: center; padding: 0; margin-top: 5px; font-size: 20px; width: calc(100% - 10px);"
      >
        <div style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
          {{ template.name }}
        </div>
      </v-card-title>

      <div
          v-if="templateType === 'userPublished' && template.userName"
          style="font-size: 12px; color: rgb(119, 119, 119);"
      >
        By: {{ template.userName}}
      </div>
    </div>
    -->

    <div>
      <v-card-title
        :title="template.name"
        style="
          line-height: 1.2;
          display: flex; flex-wrap: nowrap; gap: 10px;
        "
      >
        <v-icon x-medium style="font-size: 24px;">mdi-table-large</v-icon>
        <div style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 80%; font-size: 18px;">
          {{ template.name }}
        </div>
        <v-icon v-if="template && template.isLocked" color="red">mdi-lock</v-icon>
      </v-card-title>
      <v-card-subtitle style="padding: 10px 15px 0; width: calc(100% - 20px);">
        <div style="text-align: left; line-height: 1.2; margin-top: 3px;">
          {{ template.description }}
        </div>
        <div
          style="
                        font-size: 10px;
                        margin-top: 10px;
                        line-height: 1.2;
                        height: 40px;
                        overflow: hidden;
                      "
        >
          {{ getSoldItems }}
        </div>
      </v-card-subtitle>
    </div>

    <div>
      <v-card-text style="display: flex; justify-content: space-between;">
        <div style="font-size: 10px; color: #777;">
          {{ timestampFormatted }}
        </div>
        <v-chip
            v-if="template.isPublished"
            color="green"
            text-color="white"
            small
            style="font-size: 12px;"
        >
          {{ translate('ui_is_published') }}
        </v-chip>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="justify-space-between" style="background: #f6f6f6c4; padding: 2px 10px 2px 15px;">
        <BuyBtn :template="template" size="x-small"/>

        <v-btn
          v-if="!template.price"
          x-small
          color="blue darken-1"
          outlined
          style="background: #fff; font-weight: bold; margin-right: 20px;"
          @click="cloneTemplate"
          :disabled="!$store.getters.userCanAddNewTemplates"
        >
          <v-icon
              x-small
              style="margin-right: 2px;"
          >mdi-content-copy
          </v-icon>
          {{ translate('ui_clone_btn') }}
        </v-btn>

        <v-btn
            :disabled="template.isLocked"
            color="error lighten-1"
            style="color: #fff; margin-left: auto;"
            icon
            @click="removeTemplate"
            :title="translate('ui_delete_btn')"
        >
          <v-icon small>mdi-delete</v-icon>
        </v-btn>

      </v-card-actions>
    </div>
  </v-card>
</template>
<script>
import Mixin from '@/mixins/mixin';
import BuyBtn from '@/components/BuyBtn.vue';

export default {
  name: 'TemplateGalleryUserItem',
  components: { BuyBtn },
  props: {
    isMine: {},
    loading: {},
    onTemplateGalleryItemClick: Function,
    template: {},
    timestampFormatted: String,
  },
  mixins: [Mixin],
  computed: {
    getSoldItems() {
      let oneString = '';
      try {
        const { coreResources } = this.template.data;
        const result = coreResources.filter((cr) => cr.rel === 'service').map((cr) => cr.name);
        oneString = result.join('; ');
        if (oneString.length > 120) {
          oneString = `${oneString.slice(0, 120)}...`;
        }
      } catch (e) {
        console.error(e);
      }
      return oneString;
    },
  },
  methods: {
    removeTemplate(event) {
      event.preventDefault();
      event.stopPropagation();
      this.$store.dispatch('removeTemplate', { template: this.template });
    },
    async cloneTemplate(event) {
      event.preventDefault();
      event.stopPropagation();
      await this.$store.dispatch('cloneTemplate', this.template);
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
      this.$store.dispatch('getUserData');
    },
  },
};
</script>
